import { useCallback, useEffect } from 'react';
export const useListenToKeyDown = (keyNames, action) => {
  const onKeyDown = useCallback(event => {
    if (keyNames.includes(event.key)) {
      action();
    }
  }, [keyNames, action]);
  useEffect(() => {
    window.addEventListener('keydown', onKeyDown);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [onKeyDown]);
};
//# sourceMappingURL=useListenToKeyDown.js.map